// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"b9296e70","467":"eebbb23b","472":"a26b5165","523":"d3bb254a","553":"55bd2c93","787":"99a1ef05","879":"099e7f4d"}[chunkId] + ".chunk.js";
};